import {gql} from "apollo-boost";
import i18n  from "../../../i18n";

const contacts = {
    query : () => gql`query {
        contacts(
            count      : 9999 # paginator
            is_company : 1    # where
            orderBy    : [
                { field : "company_name", order : ASC },
                { field : "first_name", order : ASC },
                { field : "last_name", order : ASC }
            ]
        ){ data {
            id
            company_name
            first_name
            last_name
            address_number
            street
            number
            zip
            city
        } } }`,
    onResponse(fnResponse){
        return (...args) => {
            let result = contacts.dataFilterError(...args);

            result = contacts.dataToSelect(...result);
            result = contacts.dataPrependSelectOptionNone(...result);

            return fnResponse(...result);
        }
    },
    dataFilterError({loading, error, data : { contacts : { data : gqlData} = { data : []} }}){
        if (error) {
            console.log(error);
            return null;
        }

        return [gqlData, loading];
    },
    dataToSelect(data, ...args)
    {
        data = data || [];
        data = data.map((entity) => {
            let {id, company_name, salutation, first_name, last_name, address_number} = entity;
            salutation   = salutation || '';
            salutation   = salutation.length ? salutation+' ' : '';
            company_name = company_name || '--';

            return {
                label : [company_name].join('').trim(),
                value : parseInt(id),
                entity: entity,
            };
        });
        return [data, ...args];
    },
    dataPrependSelectOptionNone(data, ...args)
    {
        data.length && data.unshift({ // add beginning
            label : i18n.get('contacts.no_company'),
            value : 0,
        });

        return [data, ...args];
    },
};

export default contacts;
